import styled from 'styled-components';

export const Divider = styled.div`
	height: 1px;
	opacity: 0.5;
	background: ${({ theme }) => theme.colors.white};
`;
